import React from 'react';
export function Footer() {
  return <footer className="bg-zinc-950 py-12 border-t border-zinc-900" data-id="element-29">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col items-center text-center" data-id="element-30">
        <img src="https://cdn.magicpatterns.com/uploads/8CfYW3AghwKD7VWCJFg2Vy/Untitled_design.png" alt="BloomMind Logo" className="h-14 w-auto mix-blend-screen opacity-80 mb-6" data-id="element-31" />

        <p className="text-zinc-500 text-sm max-w-2xl mb-8 leading-relaxed" data-id="element-32">
          This is an educational digital product. Results not guaranteed. You
          are responsible for your own business decisions. The strategies
          discussed are for informational purposes only.
        </p>

        <div className="flex items-center gap-6 text-sm text-zinc-600" data-id="element-33">
          <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-34">
            Terms
          </a>
          <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-35">
            Privacy
          </a>
          <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-36">
            Contact
          </a>
        </div>

        <p className="text-zinc-700 text-xs mt-8" data-id="element-37">
          &copy; {new Date().getFullYear()} BloomMind. All rights reserved.
        </p>
      </div>
    </footer>;
}